import { useTranslation } from '@/hooks/useTranslation';
import { CriteriaRatingTable } from './CriteriaRatingTable';
import { scopeCriteriaChoices } from '../picker/IroScopePicker';
import { IroFormula } from './IroFormula';
import { ScopeValueDefinition } from '@/graphql/generated';

export function ScopeCriteriaDefinition({
  definitions,
}: {
  definitions: ScopeValueDefinition[];
}) {
  const { t } = useTranslation();
  const items = scopeCriteriaChoices();
  return (
    <div>
      <h1 className="p-8 bg-gray-50 border-b border-gray-100 title-h3 capitalize">
        {t('iro.criteria.scope.title')}
      </h1>
      <div className="p-8 space-y-8">
        <p className="">{t('iro.criteria.scope.definition')}</p>
        <hr />
        <div className="space-y-2">
          <h2 className="title-h4">{t('iro.criteria.rating.title')}</h2>
          <CriteriaRatingTable items={items} definitions={definitions} />
        </div>
        <hr />
        <div className="space-y-2">
          <h2 className="title-h4">{t('iro.criteria.formula.title')}</h2>
          <IroFormula />
        </div>
      </div>
    </div>
  );
}
